import { memo } from 'react';

import { Button } from '@air/primitive-button';

type SharePrivateCreateLinkErrorProps = {
  isRetrying: boolean;
  message?: string;
  onRetry: () => void;
};

export const SharePrivateCreateLinkError = memo(
  ({
    isRetrying,
    message = "Something went wrong. We couldn't create a share link.",
    onRetry,
  }: SharePrivateCreateLinkErrorProps) => (
    <div className="flex flex-col items-center gap-4 py-6 text-center" data-testid="SHARE_LINK_ERROR_STATE">
      <p className="ads:text-metadata text-16 text-gray-10">{message}</p>
      <Button appearance="filled" color="gray" disabled={isRetrying} onClick={onRetry}>
        Try again
      </Button>
    </div>
  ),
);

SharePrivateCreateLinkError.displayName = 'SharePrivateCreateLinkError';
